import React, { useState } from "react";   
import "./CSS/Modal.css";



// Modal Component
const Modal = ({ isOpen, onClose, currentPath }) => {
  if (!isOpen) return null;

const [status, setStatus] = useState({ loading: false, error: "", ok: false });


const handleSubmit = async (e) => {
    e.preventDefault();
    if (status.loading) return;

    const f = e.currentTarget;
    const formData = {
      name: f.elements["name"].value.trim(),
      email: f.elements["email"].value.trim(),
      businessName: f.elements["business-name"].value.trim(),
      message: f.elements["message"].value.trim(),
      path: currentPath || window.location.pathname,
    };

    // minimal validation
    if (!formData.email || !formData.message) {
      setStatus({ loading: false, error: "Email and message are required.", ok: false });
      return;
    }

    try {
      setStatus({ loading: true, error: "", ok: false });

      const res = await fetch("/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const text = await res.text();
      if (!res.ok) throw new Error(text || `HTTP ${res.status}`);

      setStatus({ loading: false, error: "", ok: true });
      // optional: close after success delay
      setStatus({ loading: false, error: "", ok: true });
setTimeout(() => onClose?.(), 600); // shorter delay (or 0 if you want instant close)
    } catch (err) {
      console.error("Failed to send email:", err);
      setStatus({
        loading: false,
        error: err?.message || "Error sending email. Please try again later.",
        ok: false,
      });
    }
  };
  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          X
        </button>
        <h2>Contact Us</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              style={{ padding: "15px", fontFamily: "Montserrat, sans-serif" }}
              id="name"
              name="name"
              placeholder="Name"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              style={{ padding: "15px", fontFamily: "Montserrat, sans-serif" }}
              id="email"
              name="email"
              placeholder="Email"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="text" // Change type from 'business name' to 'text'
              style={{ padding: "15px", fontFamily: "Montserrat, sans-serif" }}
              id="business-name"
              name="business-name"
              placeholder="Name of Business"
              required
            />
          </div>
          <div className="form-group">
            <textarea
              id="message"
              style={{ padding: "15px", fontFamily: "Montserrat, sans-serif" }}
              name="message"
              placeholder="Message"
              required
            ></textarea>
          </div>
<button
  type="submit"
  className="submit-button bg-black text-white"
  style={{ padding: "15px", fontFamily: "Montserrat, sans-serif" }}
  disabled={status.loading || status.ok}   // disable while sending and after sent
>
  {status.loading ? "Sending..." : status.ok ? "Sent!" : "Send"}
</button>


        </form>
      </div>
    </div>
  );
};

export default Modal;
